import { useState, useEffect, useRef } from "react";
import "./select_multiple.scss";

const SelectMultiple = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const containerRef = useRef(null);
  const searchRef = useRef(null);

  // Default value to an array
  const selectedValues = Array.isArray(props.value) ? props.value : [];

  // Filter out any placeholder/empty option
  const validOptions = props.options?.filter(opt => opt.value !== "") || [];

  // Filter options by search
  const filteredOptions = validOptions.filter(opt =>
    opt.label.toLowerCase().includes(search.toLowerCase())
  );

  // Close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Auto-focus search when opened
  useEffect(() => {
    if (isOpen && searchRef.current) {
      searchRef.current.focus();
    }
  }, [isOpen]);

  const handleOptionToggle = (optionValue) => {
    let newSelected;
    if (selectedValues.includes(optionValue)) {
      newSelected = selectedValues.filter((v) => v !== optionValue);
    } else {
      newSelected = [...selectedValues, optionValue];
    }

    if (props.onChange) {
      props.onChange({
        target: {
          id: props.id,
          name: props.id,
          value: newSelected,
        },
      });
    }
  };

  const handleRemoveValue = (e, optionValue) => {
    e.stopPropagation();
    const newSelected = selectedValues.filter((v) => v !== optionValue);
    if (props.onChange) {
      props.onChange({
        target: {
          id: props.id,
          name: props.id,
          value: newSelected,
        },
      });
    }
  };

  // Find label for each selected value
  const getSelectedLabels = () => {
    return validOptions.filter(opt => selectedValues.includes(opt.value));
  };

  return (
    <div className={`form-group select-multiple-container ${props.label ? "m-1" : ""}`} ref={containerRef} style={props.style}>
      {props.label && (
        <label>
          {props.label}{" "}
          {props.required && <span style={{ color: "red" }}>(*)</span>}
        </label>
      )}
      <div 
        className={`form-control select-multiple-trigger ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedValues.length === 0 ? (
          <span className="placeholder">Select options...</span>
        ) : (
          <div className="selected-tags">
            {getSelectedLabels().map((opt) => (
              <span key={opt.value} className="tag-badge">
                {opt.label}
                <button
                  type="button"
                  className="tag-remove-btn"
                  onClick={(e) => handleRemoveValue(e, opt.value)}
                >
                  &times;
                </button>
              </span>
            ))}
          </div>
        )}
        <span className="dropdown-arrow"></span>
      </div>

      {isOpen && (
        <div className="select-multiple-dropdown">
          <div className="dropdown-search">
            <input
              ref={searchRef}
              type="text"
              className="search-input"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <div className="dropdown-list">
            {filteredOptions.map((opt) => {
              const isChecked = selectedValues.includes(opt.value);
              return (
                <div
                  key={opt.value}
                  className={`dropdown-item ${isChecked ? "selected" : ""}`}
                  onClick={() => handleOptionToggle(opt.value)}
                >
                  <span className="item-label">{opt.label}</span>
                  {isChecked && <span className="check-icon">✓</span>}
                </div>
              );
            })}
            {filteredOptions.length === 0 && (
              <div className="dropdown-empty">No options found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectMultiple;
